import MyContactCard from "../components/MyContactCard";

const Contact = () => {
  return (
    <>
      <MyContactCard />
    </>
  );
};

export default Contact;
